"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTimeFormat = getTimeFormat;
exports.getDateFormat = getDateFormat;
exports.getFormatDateFunction = getFormatDateFunction;
exports.getReformatDateFunction = getReformatDateFunction;
exports.getMonthsForLocale = getMonthsForLocale;
exports.getDayNamesForLocale = getDayNamesForLocale;
exports.getSeparator = getSeparator;
exports.getFormatSpaceFunction = getFormatSpaceFunction;
/**
 * pobranie formatu czasu (short)
 * @param locale
 * @returns
 */
function getTimeFormat(locale, timeStyle = 'short') {
    const formatted = new Intl.DateTimeFormat(locale, { timeStyle }).format(new Date(2000, 0, 2, 15, 4, 5));
    return formatted
        .replace('15', 'HH')
        .replace('03', 'hh')
        .replace('3', 'h')
        .replace('04', 'mm')
        .replace('4', 'm')
        .replace('05', 'ss')
        .replace('5', 's')
        .replace('PM', 'A')
        .replace('pm', 'a');
}
/**
 * pobranie formatu daty
 * @param locale
 * @returns
 */
function getDateFormat(locale) {
    const formatted = new Intl.DateTimeFormat(locale).format(new Date(2000, 0, 2, 3, 4, 5));
    return formatted.replace('2000', 'YYYY').replace('01', 'MM').replace('1', 'M').replace('02', 'DD').replace('2', 'D');
}
function formatPlDate(sdate) {
    return +(sdate[8] + sdate[9]) + '.' + sdate[5] + sdate[6] + '.' + sdate[0] + sdate[1] + sdate[2] + sdate[3];
    // return (sdate[8] == '0' ? sdate[9] : (sdate[8] + sdate[9])) + '.' + sdate[5] + sdate[6] + '.' + sdate[0] + sdate[1] + sdate[2] + sdate[3];
}
function formatEnDate(sdate) {
    return +(sdate[5] + sdate[6]) + '/' + +(sdate[8] + sdate[9]) + '/' + sdate[0] + sdate[1] + sdate[2] + sdate[3];
    // return (sdate[8] == '0' ? sdate[9] : (sdate[8] + sdate[9])) + '.' + sdate[5] + sdate[6] + '.' + sdate[0] + sdate[1] + sdate[2] + sdate[3];
}
function getFormatDateFunction(locale) {
    switch (locale) {
        case 'pl':
            return formatPlDate;
        case 'en':
            return formatEnDate;
        default: {
            const formatter = new Intl.DateTimeFormat(locale);
            return (sdate) => formatter.format(new Date(sdate));
        }
    }
}
/**
 * tworzy funkcję do reformatowania daty na format RFC na podstawie formatu daty
 * @param locale
 * @returns
 */
function getReformatDateFunction(locale) {
    const formatted = new Intl.DateTimeFormat(locale).formatToParts(new Date(2000, 0, 2, 3, 4, 5));
    const result = {
        format: '',
        separator: ''
    };
    for (let i = 0; i < formatted.length; i++) {
        const part = formatted[i];
        if (part.type == 'literal') {
            result.separator = part.value;
            result.format += part.value;
        }
        else {
            switch (part.value) {
                case '2000':
                    part.value = 'YYYY';
                    break;
                case '01':
                    part.value = 'MM';
                    break;
                case '1':
                    part.value = 'M';
                    break;
                case '02':
                    part.value = 'DD';
                    break;
                case '2':
                    part.value = 'D';
                    break;
            }
            result.format += part.value;
        }
    }
    //generate reparse function
    let tt = 'try {\nvar strpos = 0;var l=sdate.length;\n';
    // const strpos = 0;
    for (let i = 0; i < formatted.length; i++) {
        const part = formatted[i];
        switch (part.type) {
            case 'day':
                if (part.value == 'DD') {
                    tt += "if (l<strpos+2) return '';\n";
                    tt += 'var dd = sdate[strpos++]+sdate[strpos++];\n';
                }
                else if (part.value == 'D') {
                    if (i < formatted.length - 1 && formatted[i + 1].type == 'literal') {
                        //tt += "var p=sdate.indexOf('" + formatted[i + 1].value + "',strpos)\n";
                        //tt += "var d = sdate.substring(strpos,p);\n"
                        if (formatted[i + 1].value.length == 1) {
                            tt += "if (sdate[strpos+1] === '" + formatted[i + 1].value + "') {\n";
                        }
                        else {
                            tt +=
                                'if (sdate.substring(strpos+1,strpos+' +
                                    (formatted[i + 1].value.length + 1) +
                                    ") === '" +
                                    formatted[i + 1].value +
                                    "') {\n";
                        }
                        tt += "  if (l<strpos+1) return '';\n";
                        tt += "  var dd = '0'+sdate[strpos++];\n";
                        tt += '} else {\n';
                        tt += "  if (l<strpos+2) return '';\n";
                        tt += '  var dd = sdate[strpos++]+sdate[strpos++];\n';
                        tt += '}\n';
                        //tt += "var dd = d.length<2 ? '0'+d : d;\n"
                        // tt += "strpos = p;\n"
                    }
                    else {
                        tt += "if (l<strpos+1) return '';\n";
                        tt += 'var dd = sdate.substring(strpos);\n';
                    }
                }
                break;
            case 'month':
                if (part.value == 'MM') {
                    tt += "if (l<strpos+2) return '';\n";
                    tt += 'var mm = sdate[strpos++]+sdate[strpos++];\n';
                }
                else if (part.value == 'M') {
                    if (i < formatted.length - 1 && formatted[i + 1].type == 'literal') {
                        tt += "if (sdate[strpos+1] === '" + formatted[i + 1].value + "') {\n";
                        tt += "  if (l<strpos+1) return '';\n";
                        tt += "  var mm = '0'+sdate[strpos++];\n";
                        tt += '} else {\n';
                        tt += "  if (l<strpos+2) return '';\n";
                        tt += '  var mm = sdate[strpos++]+sdate[strpos++];\n';
                        tt += '}\n';
                        // tt += "var p=sdate.indexOf('" + formatted[i + 1].value + "',strpos)\n";
                        // tt += "var m = sdate.substring(strpos,p);var mm = m.length<2 ? '0'+m : m;\n"
                        // tt += "strpos = p;\n"
                    }
                    else {
                        tt += "if (l<strpos+1) return '';\n";
                        tt += 'var mm = sdate.substring(strpos);\n';
                    }
                }
                break;
            case 'year':
                if (part.value == 'YYYY') {
                    // tt += "var yyyy = sdate.substring(strpos,strpos+4);strpos+=4;\n";
                    tt += "if (l<strpos+4) return '';\n";
                    tt += 'var yyyy = sdate[strpos++]+sdate[strpos++]+sdate[strpos++]+sdate[strpos++];\n';
                }
                else if (part.value == 'YY') {
                    tt += "if (l<strpos+2) return '';\n";
                    tt += "var yyyy = '20'+sdate[strpos++]+sdate[strpos++];\n";
                    /*
                              if (i < formatted.length - 1 && formatted[i + 1].type == "literal") {
                                  tt += "var p=sdate.indexOf('" + formatted[i + 1].value + "',strpos)\n";
                                  tt += "var y = sdate.substring(strpos,p);var yyyy = y.length==2 ? '20'+y : y;\n"
                                  tt += "strpos = p;\n"
          
                              }
                              */
                }
                break;
            case 'literal':
                if (part.value.length == 1) {
                    tt += 'strpos++;\n';
                }
                else {
                    tt += 'strpos+=' + part.value.length + '\n';
                }
                break;
        }
    }
    tt += "return yyyy+'-'+mm+'-'+dd;\n";
    tt += "} catch { return ''; }\n";
    return new Function('sdate', tt);
}
/**
 * pobierz nazwy miesięcy z local
 * @param locale
 * @param monthType 'long' | 'short'
 * @returns
 */
function getMonthsForLocale(locale, monthType = 'long') {
    const format = new Intl.DateTimeFormat(locale, { month: monthType });
    const months = [];
    for (let month = 0; month < 12; month++) {
        const testDate = new Date(Date.UTC(2000, month, 1, 0, 0, 0));
        months.push(format.format(testDate));
    }
    return months;
}
/**
 * dni tygodnia
 * @param locale
 * @param weekdayType 'long' | 'short'
 * @returns
 */
function getDayNamesForLocale(locale, weekdayType = 'long') {
    const format = new Intl.DateTimeFormat(locale, { weekday: weekdayType });
    const weekdays = [];
    for (let day = 1; day <= 7; day++) {
        const testDate = new Date(Date.UTC(2024, 0, day, 0, 0, 0));
        weekdays.push(format.format(testDate));
    }
    return weekdays;
}
function getSeparator(locale, separatorType = 'decimal') {
    var _a;
    const numberWithGroupAndDecimalSeparator = 10000.1;
    return (_a = Intl.NumberFormat(locale)
        .formatToParts(numberWithGroupAndDecimalSeparator)
        .find((x) => x.type === separatorType)) === null || _a === void 0 ? void 0 : _a.value;
}
function getFormatSpaceFunction(locale) {
    return Intl.NumberFormat(locale, { maximumFractionDigits: 2 }).format;
}
//# sourceMappingURL=intlFunctions.js.map